import { useCallback } from "react";
import axios from "axios";
import { REACT_APP_ACR_API_BASE_URL, REACT_APP_ACR_API_PROTOCOL } from "../utlities/core.constants";

// DEV ONLY: Toggle to true to bypass API and use demo analytics data.
const ENABLE_ANALYTICS_DEMO_MODE = false;

// DEV ONLY: Edit these values to simulate analytics API responses.
const DEMO_ANALYTICS_RESPONSE = {
  generatedAtUtc: null, // Uses current UTC time when null.
  totalAcrs: {
    available: true,
    value: 1,
    error: null
  },
  acrsLast30Days: {
    available: true,
    value: null,
    error: "query_failed"
  },
  activeBuyers: {
    available: true,
    value: 1,
    error: null
  },
  activeVendors: {
    available: false,
    value: null,
    error: "query_failed"
  },
  totalProducts: {
    available: true,
    value: 3,
    error: null
  }
};

export default function useAnalytics() {
  const isValidAnalyticsPayload = (payload) => {
    if (!payload || typeof payload !== "object") {
      return false;
    }

    const requiredMetrics = [
      "totalAcrs",
      "acrsLast30Days",
      "activeBuyers",
      "activeVendors",
      "totalProducts"
    ];

    return requiredMetrics.every((key) => {
      const metric = payload[key];
      return metric && typeof metric === "object" && "available" in metric && "value" in metric && "error" in metric;
    });
  };

  const getAnalytics = useCallback(async () => {
    if (ENABLE_ANALYTICS_DEMO_MODE) {
      const demoPayload = {
        ...DEMO_ANALYTICS_RESPONSE,
        generatedAtUtc: DEMO_ANALYTICS_RESPONSE.generatedAtUtc || new Date().toISOString()
      };

      return {
        ok: true,
        data: demoPayload
      };
    }

    try {
      const response = await axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/analytics`);
      const isSuccessfulResponse = response?.status === 200;
      const isValidPayload = isValidAnalyticsPayload(response?.data);

      if (!isSuccessfulResponse || !isValidPayload) {
        return { ok: false, data: null };
      }

      return { ok: true, data: response.data };
    } catch (e) {
      return { ok: false, data: null };
    }
  }, []);

  return { getAnalytics };
}
